export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_USER = 'GET_USER';
export const VERIFY_OTP = 'VERIFY_OTP';
export const RESEND_OTP = 'RESEND_OTP';
export const SEND_OTP = 'SEND_OTP';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const MARK_FORUM_LIKE = 'MARK_FORUM_LIKE';
export const MARK_FORUM_EDIT = 'MARK_FORUM_EDIT';
export const GET_SIMULATION = 'GET_SIMULATION';
export const GET_SIMULATION_ID = 'GET_SIMULATION_ID';
export const GET_SIMULATION_ID_DASHBOARD = 'GET_SIMULATION_ID_DASHBOARD';
export const GET_LAST_SIMULATION = 'GET_LAST_SIMULATION';
export const GET_SIMULATION_BY_USER = 'GET_SIMULATION_BY_USER';
 export const FEEDBACKS = 'FEEDBACKS';
export const GET_FEEDBACKS = 'GET_FEEDBACKS';
export const GENERATE_NEW_FEEDBACKS = 'GENERATE_NEW_FEEDBACKS';
export const SAVE_NEW_FEEDBACKS = 'SAVE_NEW_FEEDBACKS';
export const CREATE_NEW_FEEDBACKS = 'CREATE_NEW_FEEDBACKS';
export const CREATE_COACH_TIVY_FEEDBACKS = 'CREATE_COACH_TIVY_FEEDBACKS';
export const CREATE_DONOR_SIMULATION_FEEDBACKS = 'CREATE_DONOR_SIMULATION_FEEDBACKS';
export const GET_COACH_TIVY_FEEDBACKS = 'GET_COACH_TIVY_FEEDBACKS';
export const GET_DONOR_SIMULATION_FEEDBACKS = 'GET_DONOR_SIMULATION_FEEDBACKS';
export const SAVE_TRANSCRIPTION = 'SAVE_TRANSCRIPTION';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_IMAGE = 'EDIT_IMAGE';
export const CREATE_QUICK_PRACTICE = 'CREATE_QUICK_PRACTICE';
export const GET_PRACTICE = 'GET_PRACTICE';
export const GET_COACH_TIVY = 'GET_COACH_TIVY';
export const WEB_SCRAPPING = 'WEB_SCRAPPING';
export const CREATE_GREETING_BACKEND = 'CREATE_GREETING_BACKEND';
export const SAVE_GREETING_BACKEND = 'SAVE_GREETING_BACKEND';
export const CREATE_PERSONALIZATION = 'CREATE_PERSONALIZATION';
export const GET_PERSONALIZATION = 'GET_PERSONALIZATION';
export const SETTING_CHANGE_PASSWORD = 'SETTING_CHANGE_PASSWORD ';
export const EDIT_EMAIL = 'EDIT_EMAIL';
export const DELETE_SIMULATION = 'DELETE_SIMULATION';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
export const  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const  CALL_WEBHOOK = 'CALL_WEBHOOK';
export const FREE_SUBSCRIPTION = 'FREE_SUBSCRIPTION';
export const GET_CARDS = 'GET_CARDS';
export const ADD_CARDS = 'ADD_CARDS';
export const UPDATE_CARDS = 'UPDATE_CARDS';
export const DELETE_CARDS = 'DELETE_CARDS';
export const ADD_ONS = 'ADD_ONS';
export const PLUS_MINUTES = 'PLUS_MINUTES';
export const MY_JOIN_TEAMS = 'MY_JOIN_TEAMS ';
export const STORE_SIMULATION_RATING = 'STORE_SIMULATION_RATING';
export const GET_SIMULATION_RATING = 'GET_SIMULATION_RATING';
export const GET_TRANSCRIPTION = 'GET_TRANSCRIPTION';
export const SAVE_VAPI_ASSISTANT = 'SAVE_VAPI_ASSISTANT';
export const GET_PRACTICE_SCENARIOS = 'GET_PRACTICE_SCENARIOS';
export const GET_MOST_PRACTICED_SCENARIOS = 'GET_MOST_PRACTICED_SCENARIOS';
export const PIN_SCENARIO = 'PIN_SCENARIO';
export const UNPIN_SCENARIO = 'UNPIN_SCENARIO';

export const JOIN_TEAM = 'JOIN_TEAM';
export const CREATE_TEAM = 'CREATE_TEAM';
export const GETMY_TEAM = 'GETMY_TEAM';
export const ADD_MEMBER = 'ADD_MEMBER';
export const UPDATE_LICENCE = 'UPDATE_LICENCE';
export const REMOVE_MEMBER = 'REMOVE_MEMBER';
export const LEAVE_TEAM = 'LEAVE_TEAM';

export const UPLOAD_MEMBERS = 'UPLOAD_MEMBERS';
export const GET_MEMBER_SIMULATIONS_COUNTS = 'GET_MEMBER_SIMULATIONS_COUNTS';

export const GET_MEMBER_SIMULATIONS = 'GET_MEMBER_SIMULATIONS';
export const GET_USER_BALANCE = 'GET_USER_BALANCE';

















